import React, { useState, useEffect } from "react";
import MessageLog from "../../../CommonComponents/Messages/MessageLog";
import HomeTab from "./Main/Index";
import AdminTab from "./Admin/Index";
import AddressTab from "./Address/index";
import LogisticStationHeader from "./Header/index";
import { LogisticStationContext } from "./context";
import { useFetch } from "../../../hooks/useFetch";
import { GetFullURL } from "../../..//CommonComponents/GlobalConfFiles/URLs";
import { LoadingScreen } from "../../../CommonComponents/LoadingScreen";
import TabPannel from "../../../CommonComponents/TabPannel/index";
import { useParams } from "react-router-dom";

export default function LogisticStationMain(props) {
  const [value, setValue] = useState(0);
  const [operation, setOperation] = useState("");
  const [logisticStationId, setLogisticStationId] = useState("");
  const [frontendError, setFrontendError] = useState([]);
  const params = useParams();

  const [
    _getLogisticStationData,
    _logisticStationData,
    _setLogisticStationData,
    _errorLogisticStationData,
    _setErrorLogisticStationData,
    _successLogisticStationData,
    _setSuccessLogisticStationData,
    _loadingLogisticStationData,
  ] = useFetch(GetFullURL("GetLogisticStation"), { method: "POST" });
  const [
    _getLogisticStationDD,
    _logisticStationDD,
    ,
    _errorLogisticStationDD,
    _setErrorLogisticStationDD,
    _successLogisticStationDD,
    _setSuccessLogisticStationDD,
    _loadingtLogisticStationDD,
  ] = useFetch(GetFullURL("LogisticStationDropDowns"), { method: "POST" });
  const [
    _saveLogisticStation,
    ,
    ,
    _errorSaveLogisticStation,
    _setErrorSaveLogisticStation,
    _successSaveLogisticStation,
    _setSuccessSaveLogisticStation,
    _loadingSaveLogisticStation,
  ] = useFetch(GetFullURL("SaveLogisticStation"), { method: "POST" });

  useEffect(() => {
    //when componen mounts,set ID and operation
    if (params.op) {
      setOperation(params.op);
    }
    if (params.id) {
      setLogisticStationId(params.id);
    }
  }, []);

  useEffect(() => {
    _getLogisticStationDD();
    if (logisticStationId) {
      _getLogisticStationData({ data: { id: logisticStationId } });
    }
  }, [logisticStationId]);

  const handleChange = (event, newValue) => setValue(newValue);

  const onChange = (e) => {
    const {
      target: { value, name, checked },
    } = e;
    let newValue;

    switch (e.target.type) {
      case "number":
        newValue = Number(value);
        break;
      case "checkbox":
        checked ? (newValue = "true") : (newValue = "false");
        break;

      default:
        newValue = value;
        break;
    }

    if (newValue === "select" || newValue === "SELECT") {
      newValue = "";
    }
    const newValueObject = { [name]: newValue };
    _setLogisticStationData((prevState) => {
      return { ...prevState, ...newValueObject };
    });
  };

  const contextState = {
    onChange,
    operation,
    dropDowns: _logisticStationDD || [],
    logisticStationId,
    _logisticStationData,
    _setLogisticStationData,
    frontendError,
    setOperation,
    setFrontendError,
  };

  const operationLoading =
    _loadingLogisticStationData ||
    _loadingtLogisticStationDD ||
    _loadingSaveLogisticStation;

  function clearMessages(e) {
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessSaveLogisticStation([]);
        _setSuccessLogisticStationData([]);
        _setSuccessLogisticStationDD([]);
        break;
      case "error":
        _setErrorLogisticStationData([]);
        _setErrorLogisticStationDD([]);
        _setErrorSaveLogisticStation([]);
        setFrontendError([]);
        break;
      default:
        break;
    }
  }

  return (
    <LogisticStationContext.Provider value={contextState}>
      {operationLoading && <LoadingScreen />}
      <LogisticStationHeader
        _loadingSaveLogisticStationData={_loadingSaveLogisticStation}
        _saveLogisticStation={_saveLogisticStation}
      />
      <TabPannel
        value={value}
        handleChange={handleChange}
        labels={[
          "Home",
          "Address",
          "Admin",
          "Log",
        ]}
        components={[
          HomeTab,
          AddressTab,
          AdminTab,
        ]}
      />
      <MessageLog
        errorMessages={[
          ..._errorLogisticStationDD,
          ..._errorLogisticStationData,
          ..._errorSaveLogisticStation,
          ...frontendError,
        ]}
        successMessages={[
          ..._successLogisticStationDD,
          ..._successLogisticStationData,
          ..._successSaveLogisticStation,
        ]}
        clearMessages={clearMessages}
      ></MessageLog>
    </LogisticStationContext.Provider>
  );
}
